import PropTypes from 'prop-types';
import './index.less';

/** 简单去除 script 标签，降低 XSS 风险（内容仍应来自可信后台） */
function stripScripts(html) {
    if (!html || typeof html !== 'string') {
        return '';
    }
    return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

/**
 * 富文本 HTML 只读展示（不加载 TinyMCE），用于通知详情、嘉宾介绍等场景。
 */
export default function RichContent({ value, className }) {
    const safe = stripScripts(value || '');
    return (
        <div
            className={`boss-rich-content ${className || ''}`.trim()}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: safe }}
        />
    );
}

RichContent.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
};
